import type { ApiError } from '@/errors/apiError';
import { useUtilsStore } from '@/stores/utils';
import { normalizeError } from '@/utils/normalizeError';
import { type AxiosResponse } from 'axios';
import { ref } from 'vue';

export const useFetchApi = (hideProgress = false) => {
  const data = ref<AxiosResponse | null>(null);
  const error = ref<ApiError | null>(null);
  const utilsStore = useUtilsStore();

  const fetchData = async (apiCall: () => Promise<AxiosResponse>) => {
    data.value = null;
    error.value = null;

    if (!hideProgress) {
      utilsStore.incrementLoading();
    }
    try {
      const response = await apiCall();
      data.value = response.data;
    } catch (e: unknown) {
      const normalizedError = normalizeError(e);
      error.value = 'statusCode' in normalizedError ? normalizedError as ApiError : { ...normalizedError, statusCode: 500 } as ApiError;
    } finally {
      if (!hideProgress) {
        utilsStore.decrementLoading();
      }
    }
  };

  return {
    fetchData,
    data,
    error
  };
};
